<script>
  import * as THREE from "three";
  import { onMount, setContext } from "svelte";
  import { nPointsCircle } from "../utils/geometries";
  import { mode, loaded } from "../stores/global.js";
  import Moons from "./Intro.Moons.svelte";

  const DEPTH = 100;
  const FOV = 1;
  const NEAR = 0.1;
  const FAR = 100;
  const RADIUS = 1;
  const COLOR_BG = new THREE.Color(0x000000);
  const PIXEL_RATIO =
    typeof window === "undefined" ? 2 : Math.min(window.devicePixelRatio, 2);
  const CAMERA = new THREE.PerspectiveCamera(FOV, 1, NEAR, FAR);
  const group = new THREE.Group();

  let canvas;
  let renderer;
  let scene;
  let mounted;
  let fakeTimeout;
  let rate = 0.01;

  setContext("Start", {
    CAMERA,
    FOV,
    DEPTH,
    NEAR,
    FAR,
    RADIUS,
    PIXEL_RATIO,
  });

  const tick = () => {
    renderer.render(scene, CAMERA);
    window.requestAnimationFrame(tick);
  };

  const fakeLoad = () => {
    $loaded += rate;
    $loaded = Math.min(1, $loaded);
    if ($loaded < 1) setTimeout(fakeLoad, 100);
  };

  const finishLoad = () => {
    rate = 0.05;
  };

  $: if ($mode === "loaded") finishLoad();

  onMount(() => {
    CAMERA.position.z = 38;
    CAMERA.aspect = 1;
    CAMERA.updateProjectionMatrix();

    scene = new THREE.Scene();
    scene.background = COLOR_BG;
    scene.add(CAMERA);
    scene.add(group);
    renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      powerPreference: "high-performance",
    });
    renderer.setSize(150, 150);
    renderer.setPixelRatio(PIXEL_RATIO);

    const geometry = nPointsCircle(60, 0.33);
    const material = new THREE.PointsMaterial({ color: 0xcccccc });

    const mesh = new THREE.Points(geometry, material);

    group.add(mesh);

    mounted = true;
    tick();
    fakeLoad();
  });
</script>

<canvas bind:this="{canvas}"></canvas>

{#if mounted}
  <Moons planet="{group}" percentage="{$loaded}" />
{/if}

<style>
  canvas {
    display: block;
    outline: none;
    pointer-events: none;
    margin: 0 auto;
    border-radius: 50%;
  }
</style>
